<template>
    <v-container>
        <v-row>
            <v-col cols="6">
                <Datepicker2
                    v-if="dateBegin"
                    :dateInit="dateBegin"
                    :eventName="evNameDtBegin"
                    :monthEnable="false"
                    :showIcon="false"
                    label="Início"
                    secBegin="1"
                    />
            </v-col>
            <v-col cols="6">
                <Datepicker2
                    v-if="dateEnd"
                    :dateInit="dateEnd"
                    :eventName="evNameDtEnd"
                    :monthEnable="false"
                    label="Fim"
                    secEnd="1"
                    />
            </v-col>
        </v-row>
        <PoiRegChart
            v-if="dateBegin"
            :tags="tags"
            :dateBegin="dateBegin"
            :dateEnd="dateEnd"
            />
    </v-container>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { requestTools } from "../mixins/requestTools.js";
    import { dateTimeTools } from "../mixins/dateTimeTools.js";
    import PoiRegChart from "./PoiRegChart";
    import Datepicker2 from "./Datepicker2";

    export default {
        name: "PoiRegHistReportByHour",

        components: {
            PoiRegChart,
            Datepicker2
        },

        props: {
            tags: String
        },

        mixins: [requestTools, dateTimeTools],

        data: function () {
            return {
                evNameDtBegin: "poiRegHistByHourBeginChanged",
                evNameDtEnd: "poiRegHistByHourEndChanged",
                dateBegin: "",
                dateEnd: ""
            };
        },

        created: function () {

            EventBus.$emit("eventPageLoad", {name: "Dados históricos do POI"});
            EventBus.$on(this.evNameDtBegin, (ev) => {
                this.dateBegin = ev.datetime;
                this.resetDatepicker();
            });
            EventBus.$on(this.evNameDtEnd, (ev) => {
                this.dateEnd = ev.datetime;
                this.resetDatepicker();
            });

            this.dateBegin = this.dateTimeAddHours(this.dateTimeNow(), -24);
            this.dateEnd = this.dateTimeNow();
        },

        filters: {
        },

        methods: {
            resetDatepicker() {

                const dateBegin = this.dateBegin;
                const dateEnd = this.dateEnd;

                this.dateBegin = "";
                this.dateEnd = "";

                setTimeout(() => {
                    this.dateBegin = dateBegin;
                    this.dateEnd = dateEnd;
                }, 1);
            }
        }
    };
</script>

<style>
    .main-card {
        margin-top:5px;
    }

    .ui-um {
        font-size: 10px;
    }
</style>
